/**
 * Sanitize HTML for safe use with dangerouslySetInnerHTML.
 * Only allows <strong>, <em>, <br> (and closing tags). All other tags and angle brackets are escaped.
 */
export function sanitizeHtmlAllowSafe(html: string): string {
  if (!html || typeof html !== 'string') return '';
  const allowedTags = ['<strong>', '</strong>', '<em>', '</em>', '<br>', '<br/>', '<br />'];
  let out = html;
  const placeholder = '\u0001';
  for (const tag of allowedTags) {
    out = out.split(tag).join(placeholder + tag + placeholder);
  }
  out = out.replace(/</g, '&lt;').replace(/>/g, '&gt;');
  for (const tag of allowedTags) {
    out = out.replace(placeholder + tag + placeholder, tag);
  }
  return out;
}
